<template>
	<jdialog
		title="供货价加润设置"
		:visible.sync="dialogVisible"
		:isComponent="true"
		@handleCancel="dialogVisible = false"
		width="560px"
	>
		<el-form
			label-width="120px"
			class="form"
			:rules="rule"
			:model="form"
			ref="form"
		>
			<p style="color:red;">
				商品供货价=供应链成本价*（1+加润百分比）+固定加润值
			</p>

			<el-form-item label="加润百分比：" prop="supply_add_profit_percent">
				<el-input
					placeholder="请输入百分比数值"
					v-model="form.supply_add_profit_percent"
					:min="0"
					:max="100"
					type="number"
				>
					<template slot="append">%</template>
				</el-input>
			</el-form-item>
			<el-form-item label="固定加润值：" prop="supply_add_profit_value">
				<el-input
					placeholder="请输入固定数值"
					v-model="form.supply_add_profit_value"
					:min="0"
					type="number"
				>
					<template slot="append">元</template>
				</el-input>
			</el-form-item>

			<div class="btns">
				<el-button :loading="loading" type="primary" @click="onConfirmClick"
					>确 定</el-button
				>
				<el-button @click="dialogVisible = false">取 消</el-button>
			</div>
		</el-form>
	</jdialog>
</template>

<script>
import { getSupplyPrice, setSupplyPrice } from '../../api/goods'
export default {
	props: {
		// 是否显示
		visible: {
			default: false
		}
	},
	data() {
		return {
			dialogVisible: false,
			loading: false,
			prData: {
				supply_add_profit_percent: 0,
				supply_add_profit_value: 0
			},
			form: {
				supply_add_profit_percent: 0,
				supply_add_profit_value: 0
			},
			rule: {
				supply_add_profit_percent: [
					{ required: true, message: '请输入百分比数值', trigger: 'blur' }
				],
				supply_add_profit_value: [
					{ required: true, message: '请输入固定数值', trigger: 'blur' }
				]
			}
		}
	},
	watch: {
		dialogVisible(newV) {
			this.$emit('update:visible', newV)
		},
		visible(newV) {
			this.dialogVisible = newV
			this.form.supply_add_profit_percent = this.prData.supply_add_profit_percent
			this.form.supply_add_profit_value = this.prData.supply_add_profit_value
		}
	},
	created() {
		//获取设置
		getSupplyPrice().then(res => {
			this.prData = res
			this.form.supply_add_profit_percent = res.supply_add_profit_percent
			this.form.supply_add_profit_value = res.supply_add_profit_value
		})
	},
	methods: {
		onConfirmClick() {
			this.$refs.form.validate(valid => {
				if (valid) {
					this.loading = true
					const data = Object.assign({}, this.form)
					setSupplyPrice(data)
						.then(() => {
							this.prData = data
							this.loading = false
							this.$message.success('修改保存成功！')
						})
						.catch(() => {
							this.loading = false
						})
				} else {
					return false
				}
			})
		}
	}
}
</script>
<style lang="scss" scoped>
.form {
	padding: 10px;
	.btns {
		text-align: right;
		padding-top: 10px;
	}
}
</style>
